<template>
  <div class="flex items-center gap-[16px] mb-[24px]">
    <div
      v-for="(step, index) in schema"
      :key="step"
      class="flex-1 flex items-center gap-[8px] step-connector"
      :class="{'step-connector--done': stepStatuses[index].done}"
    >
      <span
        class="w-6 h-6 flex items-center justify-center rounded-full transition-all duration-300"
        :class="{'bg-[#34A770] text-[#626262]' : stepStatuses[index].done, 'bg-[#F95031] text-[#F95031]' : stepStatuses[index].active, 'bg-[#828282] text-[#626262]' : !stepStatuses[index].active}"
      >
        <span
          v-if="!stepStatuses[index].done"
          class="text-white text-sm"
        >{{ index + 1 }}</span>
        <span
          v-else
          class="k-Checklist text-[26px] text-white"
        />
      </span>
      <span>{{ step }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StepIndicator',
  props: {
    schema: {
      type: Array,
      default: () => [],
    },
    isBundling: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      stepStatuses: [],
      stepsData: [
        {
          number: 1,
          name: 'Pilih Produk',
          done: false,
          active: true,
        },
        {
          number: 2,
          name: 'Pilih Variasi Produk',
          done: false,
          active: false,
        },
      ],
    }
  },
  computed: {
    processedSteps() {
      return this.stepsData.map(step => ({
        ...step,
        done: step.number < this.currentStep,
        active: step.number === this.currentStep,
      }))
    },
  },
  watch: {
    schema: {
      handler(newVal) {
        this.stepStatuses = newVal.map((_, index) => ({
          done: false,
          active: index === 0,
        }))
      },
      immediate: true,
    },
  },
  created() {
    this.currentStep = 1
  },
  methods: {
    goToStep(step) {
      this.stepStatuses = this.stepStatuses.map((status, index) => ({
        ...status,
        done: index < step,
        active: index === step,
      }))
    },
    /**
       * Move to the next step
       */
    nextStep() {
      this.currentStep += 1
      this.stepsData = this.stepsData.map(step => ({
        ...step,
        done: step.number < this.currentStep,
        active: step.number === this.currentStep,
      }))
    },
    /**
       * Move to the previous step
       */
    prevStep() {
      this.currentStep -= 1
      this.stepsData = this.stepsData.map(step => ({
        ...step,
        done: step.number < this.currentStep,
        active: step.number === this.currentStep,
      }))
    },
  },
}
</script>

  <style scoped>
  .step-connector {
    position: relative;
    z-index: 1;
    background-color: #fff;
  }

  .step-connector:last-child {
    &::after {
      display: none;
    }
  }

  .step-connector::after {
    content: '';
    z-index: 0;
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    display: block;
    height: 1px;
    border-top: 1px solid #E2E2E2;
    width: 50%;
    transition: width 0.3s ease;
  }
  </style>
